// libs
// eslint-disable-next-line no-unused-vars
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
// hooks
import { useRouter } from "../../hooks";
// other
import { ANALYTICS_MEASUREMENT_ID, getOrgCode } from "../../config";
import { connect } from "react-redux";

/**
 * TrackingPageViews
 */
const TrackingPageViews = ({ userDetailInformation }) => {
  const router = useRouter();
  const { pathname } = router.location;

  useEffect(() => {
    ReactGA.initialize(ANALYTICS_MEASUREMENT_ID, {
      gaOptions: {
        name: userDetailInformation.name,
        org: getOrgCode(window.location.hostname),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ReactGA.set({ page: pathname });
    ReactGA.send({ hitType: "pageview", page: pathname });
  }, [pathname]);

  return <></>;
};

const mapStateToProps = ({ basicProfileReducer }) => ({
  userDetailInformation: basicProfileReducer.userDetailInformation,
});

export default connect(mapStateToProps)(TrackingPageViews);
